var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3396",
  "data-name": "Group 3396",
  transform: "translate(-557 -552)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Right_Icon_Background",
  cx: 6,
  cy: 6,
  r: 6,
  transform: "translate(557 552)",
  fill: "#fd9526"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3395",
  "data-name": "Group 3395",
  transform: "translate(0.25 1.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_51",
  "data-name": "Ellipse 51",
  cx: 0.75,
  cy: 0.75,
  r: 0.75,
  transform: "translate(562 558.5)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2539",
  "data-name": "Rectangle 2539",
  width: 1.5,
  height: 5,
  rx: 0.75,
  transform: "translate(562 553)",
  fill: "#fff"
})))));
export default __webpack_public_path__ + "static/media/warning_new.3e5f4336.svg";
export { SvgComponent as ReactComponent };